import { createContext, useState } from "react";

const ModalContext = createContext();

export const ModalContextProvider = ({ children }) => {
    const [modal, setModal] = useState(false);

    // ModalShell handler - props can only be boolean!
    const handleModal = (value) => {
        if (typeof (value) === "boolean") {
            setModal(value);
        } else {
            setModal(false);
        }
    }

    const valueToShare = {
        modal,
        handleModal
    }

    return (
        <ModalContext.Provider value={valueToShare}>
            {children}
        </ModalContext.Provider>
    );
}

export default ModalContext;